import React from "react";
import { Navigate, Location } from "react-router-dom";
import {ErrorService} from "../service/ErrorService";

type Props = {
    children: React.ReactNode;
    location: Location;
};

type State = {
    hasError: boolean;
    error?: Error;
};

export class ErrorBoundary extends React.Component<Props, State> {
    state: State = { hasError: false, error: undefined };

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    async componentDidCatch(error: Error, info: React.ErrorInfo) {
        const service = ErrorService.getInstance()
        const location = window.location.pathname
        const verificationId = location.split("/")[1]
        await service.sendErrorLog(error, window.location.pathname, verificationId);

    }

    render() {
        const { hasError, error } = this.state;
        const { location, children } = this.props;

        if (hasError) {
            if (location.pathname === "/error") {
                return children;
            }

            return (
                <Navigate
                    to="/error"
                    replace
                    state={{ reason: error?.message }}
                />
            );
        }

        return children;
    }
}
